import { BCMSValidate ,BCMSCurrency} from "@bcm-dev/bcms-vite";
import React, { useEffect, useState } from "react";
import { SVGAsset } from "res";
import UITextInput from "../UITextInput";
import "./styles.css";

/**
 * @function UINumberInput 
 * @param {STRING} value - Allows to set the value of the text input. 
 * @param {STRING} onChange - Event handler that allows the input to change it’s value when someone is typing in it. 
 * @param {STRING} placeholder - Allows us to set a placeholder value/text that gets replaced when clicked into.
 * @returns {React.Component}
 * @example
 * <UINumberInput value="0.00" onChange={e => {handleChange(e)}}/>
 */
 export default function UINumberInput(props) {
  const placeholder = props.placeholder ?? "";
  
  const [ state, setState ] = useState({ "input" : props.value ?? "", "close" : false });
  
  const onChange = (value, evt) => {
    let newValue = BCMSValidate.isNumber(value) || value === "" ? value : state.input;


    setState({ 
      "input" : newValue, 
      "close" : value.length > 0 
    });
    if(props.onChange instanceof Function) {
        props.onChange(newValue, evt);
    }
  };
 const onFocus =(value,evt)=>{
  
  setState({ 
    "input" : value, 
    "close" : value.length > 0 
  });
      if(props.onFocus instanceof Function) {
        props.onFocus(value, evt);
    }
 }
 const onBlur =(value,evt)=>{
  
  setState({ 
    "input" : value, 
    "close" : value.length > 0 
  });
      if(props.onBlur instanceof Function) {
        props.onBlur(value, evt);
    }
 }
  // Added useEffect to reset state when the props.value is either undefined or is an empty string
  useEffect(() => {
    const defaultState = { "input" : "", "close" : false };
    if((props.value === undefined || props.value === "") && state !== defaultState) {
      setState(defaultState);
    }
    else {
      setState({ "input" : props.value, "close" : true });
    }
  }, [ props.value ]);

  return (  
                 
              <UITextInput  placeholder={placeholder} value={ state.input } onFocus={onFocus} onBlur={onBlur} onChange={ onChange } dataPoint={props.dataPoint?props.dataPoint+"_input":""} />              
       
  );
}